import { render, staticRenderFns } from "./MaterialResourcerecordlist.vue?vue&type=template&id=0ab69f99&"
import script from "./MaterialResourcerecordlist.vue?vue&type=script&lang=js&"
export * from "./MaterialResourcerecordlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports